<template>
  <div class="invite-root" :style="cssVars()">
    <div class="custom-nav-block" :style="{ 'padding-top': `${barHeight}px` }">
      <van-nav-bar class="van-bar" title="">
        <template #left>
          <div class="left-container" @click="handleBack">
            <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
            <span class="tit-left">{{ $t('lang.Invite.k006') }}</span>
          </div>
          <img class="rules-icon" src="./images/rules-tips1.png" alt="" @click.self="handleToRules" />
        </template>
        <template v-if="baseInfo && baseInfo.avatar" #right>
          <div class="target-avatar" @click="handleToAgentProfile">
            <img :src="baseInfo.avatar | imgPath" alt="" style="object-fit: cover" />
          </div>
        </template>
      </van-nav-bar>
    </div>
    <div :style="`min-height: ${barHeight + 46}px`"></div>

    <div class="invite-top-bg">
      <div class="top-bg-img">
        <!-- Earn up to .... -->
        <p class="earn-tips" v-if="baseInfo">
          {{ $t('lang.Invite.k015') }}
          <i class="earn-percent">{{ baseInfo.maxShareRate || '' }}%</i>
          {{ $t('lang.Invite.k016') }}
        </p>

        <!-- Invite Hostess -->
        <div class="invite-hostess">
          <div @click="handleInvite" class="">{{ $t('lang.Invite.k014') }}</div>
        </div>

        <!-- Invitation code -->
        <div class="invite-code" v-if="baseInfo" @click="handleCopyCode">
          {{ $t('lang.Invite.k009') }}：
          <i class="code-yellow">{{ baseInfo.inviteCode || '' }}</i>
          <img src="./images/copy.png" />
        </div>
      </div>

      <span class="policy-flag" @click.self="handleToPolicy">{{ $t('lang.Invite.k010') }}</span>
    </div>

    <!-- tab switch -->
    <div class="switch-tab" style="position: sticky; z-index: 999" :style="`top: ${barHeight + 46}px;`">
      <div class="tab" :class="{ 'active-tab': tabIndex == tabEnmu.dashboard }" @click.stop="handleSwitchTab(tabEnmu.dashboard)">
        {{ $t('lang.Invite.k057') }}
      </div>
      <div class="tab" :class="{ 'active-tab': tabIndex == tabEnmu.hostes }" @click.stop="handleSwitchTab(tabEnmu.hostes)">
        {{ $t('lang.Invite.k008') }}
      </div>
      <div class="tab" :class="{ 'active-tab': tabIndex == tabEnmu.commission }" @click.stop="handleSwitchTab(tabEnmu.commission)">
        {{ $t('lang.BaseCommon.k031') }}
      </div>
    </div>
    <!-- tab pane -->
    <template v-if="baseInfo">
      <!-- Invite Tab -->
      <DashboardTab v-if="tabIndex === tabEnmu.dashboard" :info="baseInfo" @hook:mounted="dashboardTabMounted" @stepChange="stepChange" />
      <!-- Invite Tab -->
      <HostesTab v-if="tabIndex === tabEnmu.hostes" :info="baseInfo" @hook:mounted="hostesTabMounted" @stepChange="stepChange" />
      <!-- Commission Tab -->
      <CommissionTab v-if="tabIndex === tabEnmu.commission" :info="baseInfo" @stepChange="stepChange" />
    </template>

    <!-- 新手指导占位用 -->
    <div v-if="rootNewGuyGuide.show" style="width: 100%; height: 300px"></div>
  </div>
</template>

<script>
import { apiFetchInviteV2HomePage, agentGuidePageStatusSetApi, agentPageTypeApi } from '@/api/invite'
import { tabEnmu } from './utils/enum'
import { pageCssVars } from './z-style-cfg.js'

import DashboardTab from './components/DashboardTab.vue'
import HostesTab from './components/HostesTab.vue'
import CommissionTab from './components/CommissionTab.vue'
import eventBus from '@/utils/eventbus.js'

// 活动指导相关
const stepOption = {
  step1: {
    targetEle: 'invite-target-cc',
    guideEle: 'invite-guide-cc',
  },
  step2: {
    targetEle: 'invite-target-dd',
    guideEle: 'invite-guide-dd',
  },
  step3: {
    targetEle: 'invite-target-aa',
    guideEle: 'invite-guide-aa',
  },
  step4: {
    targetEle: 'invite-target-ab',
    guideEle: 'invite-guide-ab',
  },
  step5: {
    targetEle: 'invite-target-ab',
    guideEle: 'invite-guide-bb',
  },
}

// 活动指导相关
const cacheDom = {
  step1: null,
  step2: null,
  step3: null,
  step4: null,
  step5: null,
}

export default {
  mixins: [pageCssVars],
  components: {
    DashboardTab,
    HostesTab,
    CommissionTab,
  },
  data() {
    return {
      tabEnmu: tabEnmu,
      tabIndex: tabEnmu.dashboard,
      // 新手指导
      rootNewGuyGuide: {
        show: false,
        currentStep: 'step1',
      },
      // 页面数据
      baseInfo: {
        actInviteBeanReward: 0,
        actInviteEndTimeStamp: 1751241600000,
        actInviteStartTimeStamp: 1746057600000,
        agentSumBean: 0,
        commissionLevelList: [
          {
            level: 'E',
            levelRate: 5,
            maxBeans: 100000,
            minBeans: 0,
          },
          {
            level: 'D',
            levelRate: 8,
            maxBeans: 300000,
            minBeans: 100000,
          },
          {
            level: 'C',
            levelRate: 10,
            maxBeans: 500000,
            minBeans: 300000,
          },
          {
            level: 'SS',
            levelRate: 30,
            maxBeans: 9223372036854776000,
            minBeans: 5000000,
          },
        ],
        currencyAmount: 0,
        currencyCode: '',
        ifNewerGuide: false,
        inviteCode: '',
        inviteCount: 0,
        maxInviteBeanReward: 0,
        maxShareRate: 0,
        walletBean: 0,
        weekAgentCommissionBeans: 0,
        weekHostDeductionBeans: 0,
        weekHostEarningBeans: 0,
        locationCode: '',
      },
      nativeScroll: null,
    }
  },
  provide() {
    return {
      newGuyGuide: this.rootNewGuyGuide,
    }
  },
  methods: {
    handleBack() {
      this.closeWeb()
    },
    // 活动指导相关
    stepChange(arg) {
      document.body.scrollTo({ top: 0 })
      this.rootNewGuyGuide.currentStep = arg

      if (arg === 'step2' || arg === 'step4' || arg === 'step5') {
        setTimeout(() => {
          this.locationTarget()
          this.showGuide()
        }, 100)
        return
      }

      // 切换tab
      if (arg === 'step3') {
        this.tabIndex = tabEnmu.hostes
        return
      }

      if (arg === 'step6') {
        this.rootNewGuyGuide.show = false
        this.showGuide()
        // 设置新手指导状态
        agentGuidePageStatusSetApi()
      }
    },
    // 活动指导相关
    dashboardTabMounted() {
      cacheDom.step1 = document.getElementById('guide-step1')
      cacheDom.step2 = document.getElementById('guide-step2')
    },
    // 活动指导相关
    hostesTabMounted() {
      cacheDom.step3 = document.getElementById('guide-step3')
      cacheDom.step4 = document.getElementById('guide-step4')
      cacheDom.step5 = document.getElementById('guide-step5')
      if (this.tabIndex === tabEnmu.hostes) {
        this.locationTarget()
        this.showGuide()
      }
    },
    // 活动指导相关
    locationTarget() {
      try {
        if (this.rootNewGuyGuide.show) {
          const targetClass = stepOption[this.rootNewGuyGuide.currentStep].targetEle
          const guideClass = stepOption[this.rootNewGuyGuide.currentStep].guideEle

          if (targetClass && guideClass) {
            let targetPos = document.getElementById(targetClass)
            let guidePos = document.getElementById(guideClass)

            if (targetPos && guidePos) {
              targetPos = targetPos.getBoundingClientRect()
              guidePos = guidePos.getBoundingClientRect()

              const scrollTop = Math.abs(targetPos.top - guidePos.top)

              document.body.scrollTo({
                top: scrollTop,
                behavior: 'smooth',
              })
            }
          }
        }
      } catch (err) {
        console.log('try catch', err)
      }
    },
    // 活动指导相关
    showGuide() {
      Object.entries(cacheDom).forEach(([stepIndex, tipsDom]) => {
        if (tipsDom) {
          if (this.rootNewGuyGuide.currentStep !== stepIndex || !this.rootNewGuyGuide.show) {
            tipsDom.style.zIndex = -999
            tipsDom.style.opacity = 0
          }
          // 是当前步骤元素
          else {
            tipsDom.style.zIndex = 99999
            tipsDom.style.opacity = 1
          }
        }
      })
    },
    // 规则页面
    handleToRules() {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'entrance', AValue: 'rules' })
      } catch (err) {
        console.log('try catch', err)
      }
      this.$router.push({ path: '/invite-v2-rules', query: { fromPage: 'invite-v2' } })
    },
    // 协议页面
    handleToPolicy() {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'entrance', AValue: 'policy' })
      } catch (err) {
        console.log('try catch', err)
      }
      // 动态的政策页面
      this.$router.push({ path: '/invite-dypolicy', query: { identity: 0, language: this.$i18n.locale, fromPage: 'invite-v2' } })
    },
    handleCopyCode() {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'button', AValue: 'copy' })
      } catch (err) {
        console.log('try catch', err)
      }

      this.handleCopy(this.baseInfo.inviteCode || '', this.$t('lang.BaseCommon.k071'))
    },
    // AgentProfile页面
    handleToAgentProfile() {
      if (this.baseInfo && this.baseInfo.ifShowContactPage) {
        this.$router.push({ path: '/agent-profile', query: { scene: '0' } })
      }
      //
      else {
        this.$client.showToast(this.$t('lang.Invite.k058'))
      }
    },
    // 邀请按钮
    handleInvite() {
      const lang = this.$client.getAppInfoLang()
      const address = this.getMatchAddress()

      const appName = this.getAppName() || 'com.client.goparty'

      const url = `https://${address}/#/download?lang=${lang}&code=${this.baseInfo.inviteCode || ''}&appName=${appName}`

      const des = this.$t('lang.Invite.k002') || "I've made 10000 beans (worth $10) here by answering calls, join me now!"

      this.$client.copyLink(`${des} # ${url}`, this.$t('lang.BaseCommon.k071'))

      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'button', AValue: 'Invite' })
      } catch (err) {
        console.log('try catch', err)
      }

      // 通知客户端打开分享面板
      try {
        const params = {
          title: 'Vava - Live video chat',
          description: des,
          url: url,
        }
        shareIntent.postMessage(JSON.stringify(params))
      } catch (err) {
        console.log('try catch', err)
      }
    },
    handleSwitchTab(index) {
      this.tabIndex = index
    },
    // 页面数据相关
    getBaseInfo() {
      apiFetchInviteV2HomePage().then((res) => {
        this.baseInfo = res || null

        // todo-调试
        // this.baseInfo.actInviteBeanReward = 2000
        // this.baseInfo.actInviteEndTimeStamp = 1751241600000
        // this.baseInfo.actInviteStartTimeStamp = 1746057600000
        // this.baseInfo.inviteCount = 0

        if (typeof this.baseInfo.inviteCount !== 'undefined') {
          try {
            window.ta && window.ta.track('agent_center', { Action: 'Display', AValue: this.baseInfo.inviteCount > 0 ? 'binded' : 'unbind' })
          } catch (err) {
            console.log('try catch', err)
          }
        }

        // 新手指导
        this.baseInfo && this.getNewGuyGuideStatus()
      })
    },
    // 新手指导状态
    getNewGuyGuideStatus() {
      const status = this.baseInfo.ifNewerGuide ? 0 : 1
      this.rootNewGuyGuide.show = !status
      // todo-调试
      // this.rootNewGuyGuide.show = true
      document.body.scrollTo({ top: 0 })
      this.$nextTick(() => {
        this.locationTarget()
        this.showGuide()
      })
    },
    initNativeScroll(event) {
      const clientH = document.documentElement.clientHeight
      const scrollH = document.body.scrollHeight
      const scrollT = event.target.scrollTop
      const distance = 400

      // 触底
      if (scrollT + clientH >= scrollH - distance) {
        if (!this.nativeScroll.lockLoad) {
          this.nativeScroll.lockLoad = true
          setTimeout(() => {
            eventBus.$emit('InviteScroll', { type: 'arriveBottom' })
          }, 100)
        }
      }

      eventBus.$emit('InviteScroll', { type: 'scroll' })
    },
    newNativeScroll() {
      document.body.addEventListener('scroll', this.initNativeScroll)
      this.nativeScroll = {
        lockLoad: false,
        finishPullUp: function () {
          this.lockLoad = false
        },
        refresh: function () {
          // this.lockLoad = false
        },
      }
    },
  },
  created() {
    agentPageTypeApi().then((resData) => {
      this.getBaseInfo()
      let initTabIndex = '0'
      const cacheTabIndex = window.sessionStorage.getItem('agentCenterTabIndex')
      initTabIndex = cacheTabIndex || this.$route.query.tab
      if (initTabIndex) {
        window.sessionStorage.removeItem('agentCenterTabIndex')
        this.handleSwitchTab(initTabIndex)
      }

      eventBus.$on('refreshInvitePage', () => {
        this.getBaseInfo()
        this.handleSwitchTab(this.tabIndex)
      })
    })
  },
  mounted() {
    this.newNativeScroll()
  },
}
</script>

<style lang="scss" scoped>
.invite-root {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 20px;
  position: relative;
  background: #f1f1fc;

  // --- .invite-top-bg > .top-bg-img | .policy-flag ---
  .invite-top-bg {
    width: 100%;
    background: var(--invite-top-gradient);
    position: relative;
    .top-bg-img {
      width: 100%;
      height: 100%;
      overflow: hidden;
      background: var(--invite-top-bg) top left / 100% auto no-repeat;

      .earn-tips {
        width: 325px;
        min-height: 72px;
        line-height: var(--lh-headline-36);
        margin: 34px auto 0;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-32);
        letter-spacing: -2px;
        color: #ffffff;
        text-shadow: 2px 2px 0px var(--invite-earn-text-shadow);
        text-align: center;
        font-style: normal;
        .earn-percent {
          font-weight: bolder;
          font-size: 36px;
          line-height: var(--lh-headline-36);
          display: inline-flex;
        }
      }

      .invite-hostess {
        width: 100%;
        margin: 30px 0 0;
        text-align: center;
        div {
          min-width: 215px;
          display: inline-block;
          min-height: 50px;
          padding: 0 10px;
          background: linear-gradient(90deg, #fff76c 0%, #ffc855 8%, #ffc956 92%, #fff96a 100%);
          box-shadow: inset 0px 2px 2px 0px #fef069, inset 0px -1px 1px 0px #e18250;
          border-radius: 100px;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-16);
          color: var(--invite-hostess-btn-color);
          line-height: var(--lh-display-48);
          text-align: center;
          font-weight: bolder;
        }
      }

      .invite-code {
        width: 100%;
        text-align: center;
        font-family: var(--number-font);
        font-size: var(--fs-12);
        color: #ffffff;
        line-height: var(--lh-label-14);
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        .code-yellow {
          color: #ffe605;
        }
        img {
          width: 16px;
          height: 16px;
          box-sizing: content-box;
          border: 10px solid transparent;
        }
      }
    }

    .policy-flag {
      position: absolute;
      bottom: 11px;
      right: 0;
      height: 24px;
      padding: 0 8px;
      background: #ffffff;
      border-radius: 12px 0px 0px 12px;
      opacity: 0.9;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-16);
      color: var(--invite-policy-color);
      line-height: var(--lh-body-24);
      text-align: center;
    }
  }

  // --- .switch-tab > .tab ---
  .switch-tab {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 16px 0 10px;
    padding-bottom: 6px;
    background-color: #f1f1fc;
    .tab {
      width: 127px;
      padding: 3px 0;
      line-height: var(--lh-title-24);
      font-family: var(--string-font);
      font-size: var(--fs-16);
      color: #b2b2b2;
      text-align: center;

      &.active-tab {
        color: #333333;
        position: relative;
        font-weight: var(--fw-700);
        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 35px;
          height: 2px;
          margin-left: -17.5px;
          background-color: #333333;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.invite-root {
  .custom-nav-block {
    position: fixed;
    top: 0px;
    z-index: 10000;
    background: var(--invite-nav-bar-bg) top left / 100% 100% no-repeat;
    width: 100%;
    .van-nav-bar {
      .van-nav-bar__content {
        .van-nav-bar__left {
          .left-container {
            display: flex;
            align-items: center;
            height: 100%;
            .tit-left {
              font-family: var(--string-font);
              font-size: var(--fs-20);
              font-weight: var(--fw-900);
              line-height: var(--lh-title-24);
              font-style: normal;
              color: #ffffff;
              text-align: left;
            }
          }
          .rules-icon {
            box-sizing: content-box;
            width: 20px;
            height: 20px;
            border: 8px solid transparent;
            margin: 0 10px;
          }
        }
        .van-nav-bar__right {
          > .target-avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: 1px solid #ffffff;
            box-sizing: border-box;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .rules-icon {
    transform: rotateY(0deg) !important;
  }

  .invite-root .invite-top-bg .policy-flag {
    right: unset;
    left: 0;
    border-radius: 0 12px 12px 0;
  }
}
</style>
